import { TEMPLATE_TYPES } from "utils/constants";
import AMELLIS from "./Amellis";
import B2B_RADIANCE_AURA_TER from "./AuraTer";
import B2B_RADIANCE_COSA from "./CosaeTer";
import DEFAULT from "./Default";
import LA_FOURGALE from "./LaFourgale";
import LMF from "./Lmf";
import B2B_MUTUAL_MOBILITY from "./MutualMobility";
import B2B_SMART_PHONE from "./SmartPhone";
import SOLYON from "./Solyon";
import MILTIS from "./Miltis";
import SNCA from "./SNCA";

const Templates = {
  [TEMPLATE_TYPES.DEFAULT]: DEFAULT,
  [TEMPLATE_TYPES.B2B_RADIANCE_COSA]: B2B_RADIANCE_COSA,
  [TEMPLATE_TYPES.B2B_RADIANCE_AURA_TER]: B2B_RADIANCE_AURA_TER,
  [TEMPLATE_TYPES.B2B_SMART_PHONE]: B2B_SMART_PHONE,
  [TEMPLATE_TYPES.B2B_SOLYON]: SOLYON,
  [TEMPLATE_TYPES.B2B_LMF]: LMF,
  [TEMPLATE_TYPES.B2B_MUTUAL_MOBILITY]: B2B_MUTUAL_MOBILITY,
  [TEMPLATE_TYPES.B2B_AMELLIS]: AMELLIS,
  [TEMPLATE_TYPES.B2B_MILTIS]: MILTIS,
  [TEMPLATE_TYPES.B2B_MILTIS_TER]: MILTIS,
  [TEMPLATE_TYPES.B2B_SNCA]: SNCA,
  [TEMPLATE_TYPES.B2B_LA_FOURGALE]: LA_FOURGALE,
};
export default Templates;
